import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { CreateOneShopExportDto, ShopDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

type UpdateExportMethodParams = {
  shopExport: CreateOneShopExportDto;
  exportId: string;
};

type UseUpdateExportMethodParams = {
  onSuccess?: () => void;
};

export default function useUpdateExportMethod(
  shop: ShopDto,
  params?: UseUpdateExportMethodParams,
) {
  /**
   * It will not work with the current popup implementation
   */
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shop.id);

  const mutation = $api.useMutation("patch", "/shops/{shopId}/exports/{exportId}");

  return useMutation({
    onSuccess: () => {
      params?.onSuccess?.();
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async ({ shopExport, exportId }: UpdateExportMethodParams) => {
      return mutation.mutateAsync({
        params: { path: { shopId: shop.id, exportId } },
        body: shopExport,
      });
    },
  });
}
